var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, CardContent, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useCreateSeason } from "../api/SeasonApiProvider";
import { ErrorView } from "../nav/Error";
import { Loading } from "../nav/Loading";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { useNumericParams } from "../utils/useNumericParams";
import { SeasonForm } from "./SeasonForm";
export var CreateSeason = function () {
    var leagueId = useNumericParams().id;
    var navigate = useNavigate();
    var mutation = useCreateSeason({
        onMutate: function () { },
        onSuccess: function (data) {
            var season = data.data;
            navigate("/leagues/".concat(season.league, "/"));
        },
        onError: function () { },
    });
    if (!leagueId) {
        return _jsx(ErrorView, { error: new Error("Missing league id") });
    }
    if (mutation.isLoading) {
        return _jsx(Loading, {});
    }
    var handleSubmit = function (form) {
        mutation.mutate(__assign(__assign({}, form), { league: leagueId }));
    };
    return (_jsx(Card, { children: _jsxs(CardContent, { children: [_jsx(ErrorSnackbar, { open: mutation.isError, message: "Failed to create season. Please try again.", onClose: function () { } }), _jsx(Typography, { variant: "h6", gutterBottom: true, children: "Create Season" }), _jsx(SeasonForm, { onSubmit: handleSubmit })] }) }));
};
